<template>
  <div class="main-content" id="content">
    <h3 class="marginBottom20">
      {{ `${type === "add" ? "新增" : type === "edit" ? "编辑" : "查看"}产品` }}
    </h3>
    <!-- <el-card style="padding-left: 50px"> -->
    <el-form
      ref="form"
      :model="form"
      label-position="left"
      label-width="100px"
      :rules="rules"
    >
      <el-form-item label="产品名称" prop="name">
        <el-input
          v-model="form.name"
          placeholder="请输入"
          style="width: 400px"
          maxlength="50"
          :disabled="disabled"
        ></el-input>
      </el-form-item>

      <el-form-item label="产品分类" prop="classifyStr">
        <el-cascader
          v-model="form.classifyStr"
          :options="classifyList"
          style="width: 400px"
          :disabled="disabled"
        ></el-cascader>
      </el-form-item>

      <el-form-item label="简介" prop="breif">
        <el-input
          type="textarea"
          v-model="form.breif"
          placeholder="请输入简介"
          style="width: 400px"
          maxlength="300"
          show-word-limit
          :rows="4"
          :disabled="disabled"
        ></el-input>
      </el-form-item>

      <el-form-item label="产品图片" prop="image">
        <FormImgUpload
          :url="form.image"
          @upload="uploadImg"
          :limit="1"
          :maxSize="20"
          :accept="'.png,.jpg,.jpeg,.svg,.tiff'"
          :multiple="true"
          :disabled="disabled"
        />
        <div v-if="!disabled" style="color: #c0c1c3">
          建议尺寸：330px*330px，图片格式：.png,.jpg,.jpeg,.svg,.tiff
        </div>
      </el-form-item>

      <el-form-item label="详情图片" prop="detailImage">
        <FormImgUpload
          :url="form.detailImage"
          @upload="uploadDetailImg"
          :limit="99"
          :maxSize="20"
          :accept="'.png,.jpg,.jpeg,.svg,.tiff'"
          :multiple="true"
          :disabled="disabled"
        />
        <div v-if="!disabled" style="color: #c0c1c3">
          图片格式：.png,.jpg,.jpeg,.svg,.tiff（支持上传多张）
        </div>
      </el-form-item>

      <el-form-item label="产品说明书" prop="productManual">
        <FormMultiFileUpload
          :files="form.productManual"
          @change="(files) => uploadMultiFile('productManual', files)"
          :disabled="disabled"
          :accept="'.pdf'"
        />
        <div v-if="!disabled" style="color: #c0c1c3">文件格式：.pdf</div>
      </el-form-item>

      <el-form-item label="产品样本" prop="productSample">
        <FormMultiFileUpload
          :files="form.productSample"
          @change="(files) => uploadMultiFile('productSample', files)"
          :disabled="disabled"
          :accept="'.pdf'"
        />
        <div v-if="!disabled" style="color: #c0c1c3">文件格式：.pdf</div>
      </el-form-item>

      <el-form-item label="CCC证书" prop="cccCertificate">
        <FormMultiFileUpload
          :files="form.cccCertificate"
          @change="(files) => uploadMultiFile('cccCertificate', files)"
          :disabled="disabled"
          :accept="'.pdf'"
        />
        <div v-if="!disabled" style="color: #c0c1c3">文件格式：.pdf</div>
      </el-form-item>

      <el-form-item label="CCC报告" prop="cccReport">
        <FormMultiFileUpload
          :files="form.cccReport"
          @change="(files) => uploadMultiFile('cccReport', files)"
          :disabled="disabled"
          :accept="'.pdf'"
        />
        <div v-if="!disabled" style="color: #c0c1c3">文件格式：.pdf</div>
      </el-form-item>

      <!-- 排序 -->
      <el-form-item label="排序" prop="sort">
        <el-input-number
          v-model="form.sort"
          placeholder="请输入"
          :disabled="disabled"
          :min="0"
          :max="9999"
          :precision="0"
          controls-position="right"
        ></el-input-number>
      </el-form-item>

      <el-form-item label="产品描述" prop="productDesc">
        <FormEditor
          :details="form.productDesc"
          @editoChange="editoChange"
          :disabled="disabled"
        />
      </el-form-item>

      <el-form-item>
        <el-button @click="revert">返回</el-button>
        <el-button type="primary" @click="submit" v-if="!disabled"
          >确认</el-button
        >
      </el-form-item>
    </el-form>
    <!-- </el-card> -->
  </div>
</template>

<script>
import {
  infoSolutionClassify,
  infoProductAdd,
  infoProductUpdate,
  infoProductView,
} from "@/api/info/product";
import FormEditor from "@/components/formComponents/formEditor";
import FormFileUpload from "@/components/formComponents/formFileUpload";
import FormImgUpload from "@/components/formComponents/formImgUpload";
import FormMultiFileUpload from "@/components/formComponents/formMultiFileUpload";
import { ETypeInfo, MTypeInfo, OTypeInfo } from "@/enums/beCurrent/EBeCurrent";

export default {
  name: "create",
  components: {
    FormEditor,
    FormFileUpload,
    FormImgUpload,
    FormMultiFileUpload,
  },
  data() {
    return {
      ETypeInfo: ETypeInfo,
      MTypeInfo: MTypeInfo,
      OTypeInfo: OTypeInfo,
      classifyList: [],
      id: this.$route.query.id,
      disabled: this.$route.query.type === "view",
      type: this.$route.query.type,
      form: {
        classifyStr: "",
        productDesc: "",
        name: "",
        fileUrl: [],
        image: [],
        detailImage: [],
        breif: "",
        productManual: [],
        productSample: [],
        cccCertificate: [],
        cccReport: [],
      },
      //校验规则
      rules: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        classifyStr: [{ required: true, message: "请输入", trigger: "blur" }],
        productDesc: [
          {
            required: true,
            message: "请输入产品描述",
            trigger: "blur",
          },
          {
            validator(_, value) {
              if (value) {
                if (value === "<p><br></p>") {
                  return Promise.reject(new Error("请输入内容"));
                }
                if (value.length > 65535) {
                  return Promise.reject(new Error("内容超出最大长度限制"));
                }
              }
              return Promise.resolve(true);
            },
          },
        ],
        image: [
          {
            required: true,
            message: "请上传产品图片",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error("请上传产品图片"));
              } else {
                callback();
              }
            },
          },
        ],
        fileUrl: [
          {
            required: true,
            message: "请上传文件",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error("请上传文件"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      loadingSubmit: false,
    };
  },
  mounted() {
    this.getClassifyList();
    if (this.id) {
      this.getView();
    }
  },
  methods: {
    /**
     * 解析 JSON 格式的文件列表数据
     * @param {string|Array} str - 数据库存储的文件 JSON 字符串或已解析数组
     * @returns {Array} 文件对象列表 [{ fileName, filePath }]
     */
    parseJsonFiles(str) {
      if (!str) return [];
      try {
        const arr = typeof str === "string" ? JSON.parse(str) : str;
        return Array.isArray(arr) ? arr : [];
      } catch (e) {
        return [];
      }
    },

    /**
     * 获取产品详情并初始化表单数据
     * @returns {Promise<void>}
     */
    async getView() {
      if (this.id) {
        const { data } = await infoProductView(this.id);
        this.form = {
          ...data,
          image: data.image ? data.image.split(",") : [],
          detailImage: data.detailImage ? data.detailImage.split(",") : [],
          fileUrl: data.fileUrl ? data.fileUrl.split(",") : [],
          classifyStr: data.classifyStr ? data.classifyStr.split(",") : [],
          breif: data.breif || "",
          productManual: this.parseJsonFiles(data.productManual),
          productSample: this.parseJsonFiles(data.productSample),
          cccCertificate: this.parseJsonFiles(data.cccCertificate),
          cccReport: this.parseJsonFiles(data.cccReport),
        };
      }
    },

    /**
     * 提交产品表单数据（支持新增与编辑）
     * @returns {Promise<void>}
     */
    async submit() {
      if (this.loadingSubmit) {
        return;
      }
      let newVal = {
        ...this.form,
        classifyId: Array.isArray(this.form.classifyStr)
          ? this.form.classifyStr[1]
          : "",
        classifyStr: Array.isArray(this.form.classifyStr)
          ? this.form.classifyStr.join(",")
          : "",
        image: Array.isArray(this.form.image) ? this.form.image.join(",") : "",
        detailImage: Array.isArray(this.form.detailImage)
          ? this.form.detailImage.join(",")
          : "",
        fileUrl: Array.isArray(this.form.fileUrl)
          ? this.form.fileUrl.join(",")
          : "",
        breif: this.form.breif || "",
        productManual:
          this.form.productManual && this.form.productManual.length
            ? JSON.stringify(this.form.productManual)
            : "",
        productSample:
          this.form.productSample && this.form.productSample.length
            ? JSON.stringify(this.form.productSample)
            : "",
        cccCertificate:
          this.form.cccCertificate && this.form.cccCertificate.length
            ? JSON.stringify(this.form.cccCertificate)
            : "",
        cccReport:
          this.form.cccReport && this.form.cccReport.length
            ? JSON.stringify(this.form.cccReport)
            : "",
      };
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loadingSubmit = true;
          if (this.type == "add") {
            infoProductAdd({
              ...newVal,
            })
              .then((res) => {
                if (res.code == 200) {
                  this.loadingSubmit = false;
                  this.$router.go(-1);
                } else {
                  this.loadingSubmit = false;
                  this.$message.error(res.msg);
                }
              })
              .catch(() => {
                this.loadingSubmit = false;
              });
          } else {
            infoProductUpdate({
              ...newVal,
              id: this.id,
            })
              .then((res) => {
                if (res.code == 200) {
                  this.loadingSubmit = false;
                  this.$router.go(-1);
                } else {
                  this.loadingSubmit = false;
                  this.$message.error(res.msg);
                }
              })
              .catch(() => {
                this.loadingSubmit = false;
              });
          }
        }
      });
    },

    /**
     * 富文本编辑器内容变更回调
     * @param {string} e - 富文本 HTML 内容
     * @returns {void}
     */
    editoChange(e) {
      this.form.productDesc = e;
    },

    /**
     * 单个文件上传回调
     * @param {string|Array} e - 文件路径或路径数组
     * @param {string} name - 上传的文件名称
     * @returns {void}
     */
    upload(e, name) {
      if (Array.isArray(e)) {
        this.form.fileUrl = [...e];
      } else {
        this.form.fileUrl = [...this.form.fileUrl, e];
      }
      this.form.firmwareName = name;
    },

    /**
     * 产品主图上传回调
     * @param {string|Array} e - 图片路径或路径数组
     * @returns {void}
     */
    uploadImg(e) {
      if (Array.isArray(e)) {
        this.form.image = [...e];
      } else {
        this.form.image = [...this.form.image, e];
      }
    },

    /**
     * 详情图片上传回调（支持上传多张图片）
     * @param {string|Array} e - 图片路径或路径数组
     * @returns {void}
     */
    uploadDetailImg(e) {
      if (Array.isArray(e)) {
        this.form.detailImage = [...e];
      } else {
        this.form.detailImage = [...this.form.detailImage, e];
      }
    },

    /**
     * 多个文件列表上传变更回调
     * @param {string} field - 对应的字段名称 ('productManual' | 'productSample' | 'cccCertificate' | 'cccReport')
     * @param {Array} files - 最新文件列表数据 [{ fileName, filePath }]
     * @returns {void}
     */
    uploadMultiFile(field, files) {
      this.form[field] = files;
    },

    /**
     * 递归转换分类级联选择器数据源
     * @param {Array} tree - 分类树形原始数组
     * @param {string} valueKey - 值的属性 Key
     * @param {string} labelKey - 标签的属性 Key
     * @returns {Array} 级联数据源
     */
    convertTreeData(tree, valueKey = "id", labelKey = "name") {
      return tree.map((node) => {
        const newNode = {
          value: node[valueKey],
          label: node[labelKey],
          disabled:
            node.parentId == 0 &&
            (!node.children || (node.children && node.children.length == 0)),
        };
        if (node.children) {
          newNode.children = this.convertTreeData(
            node.children,
            valueKey,
            labelKey
          );
        }
        return newNode;
      });
    },

    /**
     * 获取产品分类树形列表
     * @returns {void}
     */
    getClassifyList() {
      infoSolutionClassify({}).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.classifyList = this.convertTreeData(res.data);
        }
      });
    },

    /**
     * 返回上级页面
     * @returns {void}
     */
    revert() {
      this.$router.go(-1);
    },

    /**
     * 切换数据类型回调
     * @param {number} e - 类型标识
     * @returns {void}
     */
    getType(e) {
      if (e == 1) {
        this.form.content = "";
      } else {
        this.form.content = [];
      }
    },
  },
};
</script>

<style scoped>
.main-content {
  padding-left: 30px;
  padding-right: 40%;
}
</style>

